import { isLocationBasedReviewRoute } from './isLocationBasedReviewRoute';
import type { AppConfig } from '../config';

export const getLocationId = (params: {
  locationSlug?: string;
  reviewLocation: AppConfig['reviewLocation'];
}): number | undefined =>
  isLocationBasedReviewRoute({
    locationSlug: params.locationSlug,
    locationId: params.reviewLocation.id,
  })
    ? params.reviewLocation.id
    : undefined;
